(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tefora-app-locale-fallback"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('tefora-app-locale-labels');
    if (!config || window.teforaAppLocaleFallbackActive) return;
    window.teforaAppLocaleFallbackActive = true;
    const labels = new Map(
      Array.from(config.content.querySelectorAll('[data-source]'), element => [
        element.dataset.source, element.textContent.trim()
      ])
    );
    const selector = [
      '#judgeme_product_reviews .jm-review-widget-minimal-header__title',
      '#judgeme_product_reviews .jm-no-reviews-state__text',
      '#judgeme_product_reviews [data-testid="write-review-button"]',
      'button.restock-rocket-button-product'
    ].join(',');
    const update = () => {
      document.querySelectorAll(selector).forEach(element => {
        const text = element.textContent.trim();
        const translated = labels.get(text);
        if (translated && !element.children.length) element.textContent = translated;
        for (const attribute of ['aria-label', 'title']) {
          const value = element.getAttribute(attribute);
          if (value && labels.has(value.trim())) element.setAttribute(attribute, labels.get(value.trim()));
        }
      });
    };
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    };
    update();
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, characterData: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
